export {default} from 'netxcore@netx/core-auth/controller';

import {appRouter} from '@netx/core-next/instance/router';
import {session} from '@netx/core-auth/collections/singleton/session';

/**
 * @event module:auth#auth:extend
 * @param {object} NS Namespace object
 */
dispatcher.once('auth:extend', function (NS) {
	/**
	 * @event module:auth#auth:user:password:change:success
	 * @override
	 */
	dispatcher.off('auth:user:password:change:success');
	dispatcher.on('auth:user:password:change:success', function () {
		session.set({loginMsg: 'Your password was changed.  Please log in.'});
		appRouter.navigate('login', {trigger: true});
	});
});
